/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import {
  sNotAvail,
  sStart,
  sBack,
  sCancel,
  sLoginForEnroll,
  sNeedLoginAndEnroll,
  sNeedEnroll,
  sEnroll,
  sAgreeEnroll,
  sLegal,
  sEnrollDlgMsg,
} from "assets/jss/views/ResStrings";
import { addOwn, ApricotAction } from "client/actions/own";
import { Modal } from "components/Modal/Modal";
import { showHtmlText } from "client/views/Exercise/ExMain";

import coursePageStyle from "assets/jss/views/coursePage/coursePageStyle";
const styles = createStyles(coursePageStyle as any);

interface Props extends WithStyles<typeof styles> {
  addOwn: ApricotAction;
  // store data
  user: any;
  // component parameters:
  owned: boolean;
  enroll?: boolean;
  // true: user already intends to enroll (e.g. from Enroll button)
  // false: show other msg (e.g. need login)
  courses: string[];
  onExit: () => void;
  classes: any;
}

const EnrollDialogBase: React.FC<Props> = ({
  addOwn,
  user,
  owned,
  enroll = false,
  courses,
  onExit,
  classes,
}: Props) => {
  const [goSignIn, setGoSignIn] = useState(false);
  const [goEnroll, setGoEnroll] = useState(false);
  const [goExit, setGoExit] = useState(false);

  useEffect(() => {
    // if we have nothing to show, go exit on request
    if (goExit && !goSignIn && !goEnroll) {
      onExit();
    }
  }, [goExit]);

  if (goSignIn) {
    return <Redirect push to="/signin" />;
  }

  if (!user)
    // if for enroll, show: "You need to login for enrolling in the course."
    // else, show: "This feature is available after you login and enroll in the course."
    return (
      <Modal
        title={sNotAvail}
        buttons={[sStart, sCancel]}
        onButtons={(id: number) => setGoSignIn(id === 0)}
        onExit={() => setGoExit(true)}>
        {showHtmlText(enroll ? sLoginForEnroll : sNeedLoginAndEnroll)}
      </Modal>
    );

  // Logged in, and user didn't yet show intention to enroll
  if (!enroll && !goEnroll)
    // show: "This feature is available after you enroll in the course.""
    return (
      <Modal
        title={sNotAvail}
        buttons={[sEnroll, sCancel]}
        onButtons={(id: number) => setGoEnroll(id === 0)}
        onExit={() => setGoExit(true)}>
        {sNeedEnroll}
      </Modal>
    );

  // now, go Enroll (show Enroll dialog)
  return (
    <>
      {/* {showTerms && (<Modal wide title={sLegal} buttons={[sBack]} onExit={() => setShowTerms(false)}>
          <TermOfUse /></Modal>)}
      {showPolicy && (<Modal wide title={sLegal} buttons={[sBack]} onExit={() => setShowPolicy(false)}>
          <Policy /></Modal>)} */}
      <Modal
        title={sEnroll}
        color="primary"
        buttons={[sAgreeEnroll, sCancel]}
        onButtons={(id: number) => {
          if (id === 0) addOwn(user._id, courses);
          onExit();
        }}
        onExit={onExit}>
        <>
          {sEnrollDlgMsg}
          {/* <br /><br />
          {sByEnroll}&nbsp;
          <span className={classes.legalNote} onClick={() => setShowTerms(true)}>{sTerms}</span>
          &nbsp;&amp;&nbsp;
          <span className={classes.legalNote} onClick={() => setShowPolicy(true)}>{sPolicy}</span> */}
        </>
      </Modal>
    </>
  );
};

function mapStateToProps(state: any) {
  return {
    user: state.state_auth,
  };
}

const base: any = EnrollDialogBase;
export const EnrollDialog: any = withStyles(styles)(
  connect(mapStateToProps, { addOwn })(base),
);

export const EnrollDialogTest = withStyles(styles)(EnrollDialogBase);
